import { FileText, Send, TrendingUp } from "lucide-react"

interface ReportStatsProps {
  totalReports: number
  reportsSent: number
  avgGrade: string
}

export function ReportStats({ totalReports, reportsSent, avgGrade }: ReportStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-blue-100 rounded-lg text-secondary">
          <FileText className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Total Reports</p>
          <h3 className="text-2xl font-bold text-foreground">{totalReports}</h3>
        </div>
      </div>

      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-teal-100 rounded-lg text-primary">
          <Send className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Reports Sent</p>
          <h3 className="text-2xl font-bold text-foreground">{reportsSent}</h3>
        </div>
      </div>

      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-purple-100 rounded-lg text-purple-600">
          <TrendingUp className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Average Grade</p>
          <h3 className="text-2xl font-bold text-foreground">{avgGrade}</h3>
        </div>
      </div>
    </div>
  )
}
